module.exports = __webpack_public_path__ + "static/media/icon-caret-prev.32253ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-caret-prev.svg
// module id = 1234
// module chunks = 19